import { render, staticRenderFns } from "./TRF.vue?vue&type=template&id=43d1188a"
import script from "./TRF.vue?vue&type=script&lang=js"
export * from "./TRF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports